module.exports = {
	events: {
		refresh: {
			type: 'click',
			selector: 'button.refreshList',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				event.data.component.closest('templates_newsletter_segments_controller', function(controller){
					controller.find('templates_newsletter_segments_list', function(list){
						list.refreshData();
						var statusController;
						if((statusController = getComponent('statusController'))) {
							statusController.addPanel('status.done.refresh');
						}
					})
				});
			}
		}
	}
}